import React, { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import AppRoutes from "./routes/AppRoutes";
import SnackBar from "./layouts/snackbar/SnackBar";
import store from "./redux/store";
import BlockingSnackBar from "./layouts/snackbar/BlockingSnackBar";

/**
 * NOTE:
 *  - <SnackBar /> is rendered once, globally.
 *  - All snackbar logic is inside the component itself.
 */
const AppContent: React.FC = () => {
  const [user, setUser] = useState(() => {
    return !!localStorage.getItem("token");
  });

  return (
    <BrowserRouter>
      <AppRoutes
        user={user}
        onLogin={() => setUser(true)}
        onLogout={() => setUser(false)}
      />
      <SnackBar />
      <BlockingSnackBar />
    </BrowserRouter>
  );
};

const App: React.FC = () => (
  <Provider store={store}>
    <AppContent />
  </Provider>
);

export default App;
